import { v1ApiClient } from '@/services';
import type { PathParams } from '@/shared/api/generated';

type DisconnectPath = '/v1/yotpo/{yotpo_id}';

/**
 * Yotpo 연동 해제
 */
export const deleteYotpoInfo = ({
  yotpo_id,
}: PathParams<DisconnectPath, 'delete'>): Promise<void> =>
  v1ApiClient.delete(`/yotpo/${yotpo_id}`).then((res) => res.data);
